import React from 'react';
import PropTypes from 'prop-types';

import CompanyOfficeRow from './company_office_row';
import EditModal from './edit_modal';
import { save } from './api';

export default class InvoicingForm extends React.Component {
  static propTypes = {
    companyOffices: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
    companyPath: PropTypes.string.isRequired,
    features: PropTypes.shape({
      moCustomDealIds: PropTypes.bool,
    }),
  }

  state = {
    companyOffices: this.props.companyOffices,
  }

  handleEdit = (companyOffice) => {
    this.setState({
      editingCompanyOffice: companyOffice,
    });
  }

  handleEditSubmit = (companyOffice) => {
    const companyOffices = this.state.companyOffices.map((office) => {
      if (office.id === companyOffice.id) {
        return companyOffice;
      }

      return {
        ...office,
        nextInvoiceNumber: null,
      };
    });

    return save(this.props.companyPath, companyOffices);
  }

  handleEditSave = (companyOffice) => {
    this.setState(state => ({
      editingCompanyOffice: null,
      companyOffices: state.companyOffices.map(office => (
        office.id === companyOffice.id ?
          { ...companyOffice, nextInvoiceNumber: companyOffice.nextInvoiceNumber || office.nextInvoiceNumber } :
          office
      ))
    }));
  }

  handleEditCancel = () => {
    this.setState({ editingCompanyOffice: null });
  }

  showOfficeName() {
    return this.props.companyOffices.length > 1;
  }

  render() {
    return <React.Fragment>
      {this.renderTable()}
      <EditModal
        companyOffice={this.state.editingCompanyOffice}
        features={this.props.features}
        showOfficeName={this.showOfficeName()}
        onCancel={this.handleEditCancel}
        onSave={this.handleEditSave}
        onSubmit={this.handleEditSubmit}
      />
    </React.Fragment>;
  }

  renderTable() {
    const { companyOffices } = this.state;

    return (
      <div className="d-flex flex-column gap-3">
        <h5>Invoice Settings</h5>

        <div className="table-container">
          <table className="table table-sticky">
            <thead>
              <tr>
                {this.showOfficeName() && <th name="company-office-header-cell">Office</th>}
                <th>Invoice Number Prefix</th>
                <th>Next Invoice Number</th>
                <th>Remit To</th>
                <th>Notes</th>
                <th/>
              </tr>
            </thead>
            <tbody>
              {companyOffices.map(
                office => (
                  <CompanyOfficeRow
                    companyOffice={office}
                    key={office.id}
                    showOfficeName={this.showOfficeName()}
                    onEdit={this.handleEdit}
                  />
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
